import React from 'react';
import './styles.scss';
import Stepper from '../../../components/molecules/steppers';
import useRoutes from './hooks';
import Button from '../../../components/molecules/buttons';
import RoutesRoute from './route';
import Scheduled from './scheduled';
import Forms from '../../../components/organisms/forms';
import LandingHeader from '../../../components/layout/header/landing';

function Routes(): React.ReactElement {
  const {
    step, setStep, onNavigateAddRoute, onNavigateAddSchedule, handleChangeStartDate,
    selectedDate, handleChangeEndDate,
  } = useRoutes();
  return (
    <div className="py-4">
      <LandingHeader title="Routes" />
      <div className="px-4 px-xl-5">
        <div className="row">
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <Stepper.Slide
              step={step}
              setStep={setStep}
              labels={['Route', 'Schedules']}
            />
          </div>
          <div className={step === 1 ? 'col-xl-3 offset-xl-4 col-lg-4 offset-lg-2 col-md-6 col-sm-12 mb-4 mb-md-0' : 'd-none'}>
            <Forms.DateRangePicker
              id="dateRangePicker"
              handleChangeStart={handleChangeStartDate}
              handleChangeEnd={handleChangeEndDate}
              startDate={{ current: new Date(selectedDate.start), max: new Date(selectedDate.end) }}
              endDate={{ current: new Date(selectedDate.end), min: new Date(selectedDate.start) }}
            />
          </div>
          <div className={`col-xl-2 col-lg-2 col-md-3 ${step === 0 ? 'offset-md-3 offset-lg-6 offset-xl-7' : 'offset-md-9 offset-lg-0'} mb-4 mb-lg-0 col-sm-12`}>
            <Button.Default
              id="addRoute"
              type="button"
              label={step === 0 ? 'Add Route' : 'Add Schedule'}
              onClick={step === 0
                ? () => onNavigateAddRoute()
                : () => onNavigateAddSchedule()}
            />
          </div>
        </div>
        <div className="w-100">
          {step === 0 && <RoutesRoute />}
          {step === 1 && <Scheduled selectedDate={selectedDate} />}
        </div>
      </div>
    </div>
  );
}

export default Routes;
